import React, { useEffect, useState } from "react";

const FILTVAdManagerForm = ({
  form,
  setForm,
  editingCode,
  channels,
  saving,
  onSubmit,   
  onCancel,   
}) => {
  return (    
        <div className="mb-8 rounded-3xl border border-cyan-500/30 bg-white/5 p-6">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-cyan-300">
                {editingCode ? "Edit Advertisement" : "Create Advertisement"}
                </h2>
                <button
                onClick={resetForm}
                className="text-slate-300 hover:text-white w-fit px-2 py-1"
                >
                <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>

            <form
                onSubmit={async (e) => {
                e.preventDefault();
                setSaving(true);
                setMessage(null);

                try {
                    if (
                    !form.advertisementCode.trim() ||
                    !form.cartProductCode.trim() ||
                    !form.merchant.trim() ||
                    !form.lcn ||
                    !form.videoLink.trim()
                    ) {
                    setMessage({
                        type: "error",
                        text: "Advertisement Code, Product Code, Merchant, Channel and Video Link are mandatory.",
                    });
                    setSaving(false);
                    return;
                    }

                    const payload = {
                    advertisementCode: form.advertisementCode,
                    cartProductCode: form.cartProductCode,
                    lcn: Number(form.lcn),
                    merchant: form.merchant,
                    area: form.area,
                    city: form.city,
                    state: form.state,
                    pincode: form.pincode,
                    videoType: form.videoType,
                    videoLink: form.videoLink,
                    offer: form.offer,
                    offerEndsAt: form.offerEndsAt || null,
                    phone: form.phone,
                    whatsapp: form.whatsapp,
                    isActive: form.isActive,
                    };

                    let response;

                    if (editingCode) {
                    response = await fetchData({
                        url: `${FILTV_ADS_URL}/${editingCode}`,
                        method: "patch",
                        body: payload,
                        token: authState?.token,
                    });
                    } else {
                    response = await fetchData({
                        url: FILTV_ADS_URL,
                        method: "post",
                        body: payload,
                        token: authState?.token,
                    });
                    }

                    if (response) {
                    setMessage({
                        type: "success",
                        text: editingCode
                        ? "Advertisement Updated Successfully."
                        : "Advertisement Created Successfully.",
                    });
                    await load();
                    resetForm();
                    } else {
                    setMessage({
                        type: "error",
                        text: "Unable to save advertisement.",
                    });
                    }
                } catch (err) {
                    console.error(err);
                    setMessage({
                    type: "error",
                    text: "Server error while saving advertisement.",
                    });
                } finally {
                    setSaving(false);
                }
                }}
                className="space-y-8"
            >
                {/* ====================================================== */}
                {/* Basic Details                                          */}
                {/* ====================================================== */}
                <div>
                <h3 className="text-cyan-300 font-semibold mb-4">
                    Advertisement Information
                </h3>

                <div className="grid lg:grid-cols-2 gap-4">
                    <div>
                    <label className="block mb-1 text-sm">
                        Advertisement Code *
                    </label>
                    <input
                        value={form.advertisementCode}
                        disabled={!!editingCode}
                        onChange={(e) =>
                        setForm({
                            ...form,
                            advertisementCode: e.target.value,
                        })
                        }
                        className="w-full rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3 outline-none"
                    />
                    </div>

                    <div>
                    <label className="block mb-1 text-sm">
                        Cart Product Code *
                    </label>
                    <input
                        value={form.cartProductCode}
                        onChange={(e) =>
                        setForm({
                            ...form,
                            cartProductCode: e.target.value,
                        })
                        }
                        className="w-full rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    </div>

                    <div>
                    <label className="block mb-1 text-sm">Merchant *</label>
                    <input
                        value={form.merchant}
                        onChange={(e) =>
                        setForm({ ...form, merchant: e.target.value })
                        }
                        className="w-full rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    </div>

                    <div>
                    <label className="block mb-1 text-sm">
                        LCN Channel *
                    </label>
                    <select
                        value={form.lcn}
                        onChange={(e) =>
                        setForm({ ...form, lcn: e.target.value })
                        }
                        className="w-full rounded-xl border border-white/10 bg-[#0b1120] px-3 py-1"
                    >
                        <option value="">Select Channel</option>
                        {channels.map((channel) => (
                        <option key={channel.lcn} value={channel.lcn}>
                            {channel.lcn} {channel.emoji} {channel.title}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
                </div>

                {/* ====================================================== */}
                {/* Location                                                */}
                {/* ====================================================== */}
                <div>
                <h3 className="text-cyan-300 font-semibold mb-4">
                    Location Targeting
                </h3>

                <div className="grid lg:grid-cols-2 gap-4">
                    <input
                    placeholder="Area"
                    value={form.area}
                    onChange={(e) =>
                        setForm({ ...form, area: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    <input
                    placeholder="City"
                    value={form.city}
                    onChange={(e) =>
                        setForm({ ...form, city: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    <input
                    placeholder="State"
                    value={form.state}
                    onChange={(e) =>
                        setForm({ ...form, state: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    <input
                    placeholder="Pincode"
                    value={form.pincode}
                    onChange={(e) =>
                        setForm({ ...form, pincode: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                </div>

                <p className="text-xs text-slate-400 mt-2">
                    Leave all fields blank if advertisement should be visible
                    across India.
                </p>
                </div>

                {/* ====================================================== */}
                {/* Video                                                   */}
                {/* ====================================================== */}
                <div>
                <h3 className="text-cyan-300 font-semibold mb-4">Video</h3>

                <div className="grid lg:grid-cols-2 gap-4">
                    <select
                    value={form.videoType}
                    onChange={(e) =>
                        setForm({ ...form, videoType: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-3 py-1"
                    >
                    <option value="youtube">YouTube</option>
                    <option value="mp4">MP4 Video</option>
                    </select>

                    <input
                    placeholder="Video URL"
                    value={form.videoLink}
                    onChange={(e) =>
                        setForm({ ...form, videoLink: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                </div>
                </div>

                {/* ====================================================== */}
                {/* Offer                                                   */}
                {/* ====================================================== */}
                <div>
                <h3 className="text-cyan-300 font-semibold mb-4">Offer</h3>

                <textarea
                    style={{height: "50"}}
                    placeholder="Offer Details"
                    value={form.offer}
                    onChange={(e) =>
                    setForm({ ...form, offer: e.target.value })
                    }
                    className="w-full rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3 resize-none"
                />

                <div className="mt-4">
                    <label className="block mb-2">Offer Ends At</label>
                    <input
                    type="datetime-local"
                    value={form.offerEndsAt}
                    onChange={(e) =>
                        setForm({ ...form, offerEndsAt: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                </div>
                </div>

                {/* ====================================================== */}
                {/* Contact                                                 */}
                {/* ====================================================== */}
                <div>
                <h3 className="text-cyan-300 font-semibold mb-4">
                    Customer Contact
                </h3>

                <div className="grid lg:grid-cols-2 gap-4">
                    <input
                    placeholder="Phone Number"
                    value={form.phone}
                    onChange={(e) =>
                        setForm({ ...form, phone: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                    <input
                    placeholder="WhatsApp"
                    value={form.whatsapp}
                    onChange={(e) =>
                        setForm({ ...form, whatsapp: e.target.value })
                    }
                    className="rounded-xl border border-white/10 bg-[#0b1120] px-4 py-3"
                    />
                </div>
                </div>

                {/* ====================================================== */}
                {/* Active                                                  */}
                {/* ====================================================== */}
                <div>
                <label className="flex items-center gap-3">
                    <input
                    type="checkbox"
                    checked={form.isActive}
                    onChange={(e) =>
                        setForm({
                        ...form,
                        isActive: e.target.checked,
                        })
                    }
                    />
                    Advertisement Active
                </label>
                </div>

                {/* ====================================================== */}
                {/* Buttons                                                 */}
                {/* ====================================================== */}
                <div className="flex gap-3 pt-3">
                <button
                    type="submit"
                    disabled={saving}
                    className="rounded-xl bg-cyan-600 hover:bg-cyan-500 px-5 py-3 font-semibold disabled:opacity-60"
                >
                    {saving
                    ? "Saving..."
                    : editingCode
                    ? "Update Advertisement"
                    : "Create Advertisement"}
                </button>

                <button
                    type="button"
                    onClick={resetForm}
                    className="rounded-xl border border-white/10 px-5 py-3 hover:bg-white/10"
                >
                    Cancel
                </button>
                </div>
            </form>
        </div>
    );
};

export default FILTVAdManagerForm;